/**
 * Safe console wrapper to prevent errors in production environments where console might be stripped
 */
export const safeConsole = {
  log: (...args) => {
    if (process.env.NODE_ENV !== "production") {
      console.log(...args);
    }
  },
  warn: (...args) => {
    console.warn(...args);
  },
  error: (...args) => {
    console.error(...args);
  },
  info: (...args) => {
    if (process.env.NODE_ENV !== "production") {
      console.info(...args);
    }
  },
};
